const mutations = {
  UPDATE_USER(state, payload) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo')) || {}
    state.userInfo = state.userInfo || {}
    for (const property of Object.keys(payload)) {
      if (payload[property] !== null) {
        state.userInfo[property] = payload[property]
        userInfo[property] = payload[property]
      }
    }
  },
  CLEAN_USER(state) {
    state.userInfo = null
    localStorage.removeItem('userInfo')
    localStorage.removeItem('access_token')
  },
  CLEAN_ALL(state) {
    localStorage.clear()
    sessionStorage.clear()
    state = {
      ...state,
      userInfo: {},
      lang: 'it',
      loading: false,
      errorKey: null,
      errorSubKey: null,
      errorSubKeyParams: [],
      errorImage: null,
      redirect: null,
      actionRedirect: null
    }
  },
  CHANGE_LANG(state, payload) {
    state.lang = payload.lang
  },
  LOADING_STATE(state, payload) {
    state.loading = payload
  },
  SET_ERROR(state, payload) {
    state.errorKey = payload.errorKey
    state.errorSubKey = payload.errorSubKey
    state.errorSubKeyParams = payload.errorSubKeyParams
    state.errorImage = payload.errorImage
    state.redirect = payload.redirect
  },
  CLEAN_ERROR(state) {
    state.errorKey = null
    state.errorSubKey = null
    state.errorSubKeyParams = []
    state.errorImage = null
  },
  RESET_MODAL(state) {
    state.modal = false
    state.modalText = ''
  },
  OPEN_MODAL(state, payload) {
    state.modal = true
    state.modalText = payload
  }
}

export default mutations
